export interface TimezoneResponse {
  dstOffset: number;
  rawOffset: number;
  status: string;
  timeZoneId: string;
  timeZoneName: string;
}

export enum AddressComponentTypes {
  NUMBER = 'street_number',
  ROUTE = 'route',
  CITY = 'locality',
  STATE = 'administrative_area_level_1',
  COUNTRY = 'country',
}

export enum GoogleRequestResponse {
  OK = 'OK',
  INVALID_REQUEST = 'INVALID_REQUEST',
  OVER_DAILY_LIMIT = 'OVER_DAILY_LIMIT',
  OVER_QUERY_LIMIT = 'OVER_QUERY_LIMIT',
  REQUEST_DENIED = 'REQUEST_DENIED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  ZERO_RESULTS = 'ZERO_RESULTS'
}
